import React, {Fragment} from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#90e5fc'
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        borderBottomColor: '#bff0fd',
        borderBottomWidth: 1,
        alignItems: 'center',
        fontStyle: 'bold',
    },
    shareholder: {
        width: '20%',
        textAlign: 'left',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    description: {
        width: '20%',
        textAlign: 'left',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    qty: {
        width: '30%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        textAlign: 'right',
    },
    rate: {
        width: '15%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        textAlign: 'right',
    },
    amount: {
        width: '15%',
        textAlign: 'right',
    }
  });


const ShareTableRow = ({items}) => {
    const rows = items.map( item => 
        <View style={styles.row} key={item.id.toString()}>
            <Text style={styles.shareholder}>{item.shareholder_name}</Text>
            <Text style={styles.description}>{item.number_of_shares}</Text>
            <Text style={styles.qty}>{item.share_type}</Text>
            <Text style={styles.rate}>{item.purchase_date}</Text>
            <Text style={styles.amount}>{item.end_date}</Text>
        </View>
    )
    return (<Fragment>{rows}</Fragment> )
};
  
  export default ShareTableRow